(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initGoodStillCardSwatches(scope) {
  scope.querySelectorAll('[data-product-card]').forEach(card => {
    if (card.dataset.cardReady) return;
    card.dataset.cardReady = 'true';
    const image = card.querySelector('[data-card-image]');
    const noPhoto = card.querySelector('[data-card-no-photo]');
    const links = [...card.querySelectorAll('[data-card-link]')];
    const swatches = [...card.querySelectorAll('[data-card-swatch]')];
    const label = card.querySelector('[data-card-color]');
    swatches.forEach(swatch => swatch.addEventListener('click', () => {
      swatches.forEach(item => item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false'));
      const target = new URL(links[0].href);
      target.searchParams.set('variant', swatch.dataset.variantId);
      links.forEach(link => link.href = target.href);
      if (label) label.textContent = swatch.dataset.color;
      if (image) {
        image.hidden = !swatch.dataset.imageSrc;
        if (swatch.dataset.imageSrc) {
          image.src = swatch.dataset.imageSrc;
          image.alt = swatch.dataset.imageAlt;
        }
      }
      if (noPhoto) noPhoto.hidden = !!swatch.dataset.imageSrc;
    }));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGoodStillCardSwatches(document));
else initGoodStillCardSwatches(document);
document.addEventListener('shopify:section:load', event => initGoodStillCardSwatches(event.target));
  } catch(e) { console.error(e); }
})();

})();
